import { useRouter } from 'next/router';
import { DropdownItem } from 'ui-components';
import { EditIcon } from 'ui-components/dist/EditIcon';
import { ICreator } from '~/types';

interface Props {
  creator: ICreator;
}

export const EditPlatformsDropdownItem: React.FC<Props> = ({ creator }) => {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/t/${creator?.slug}/platform-connections`);
  };

  return (
    <DropdownItem
      onClick={handleClick}
      trackId="foam-talent-menu-edit-platforms"
    >
      <EditIcon boxSize={4} />
      Edit Platforms
    </DropdownItem>
  );
};
